/**
 * 自动整定状态 Store（Zustand）
 * 管理自动整定进度、结果和历史记录
 */
import { create } from 'zustand';
import type { PidLoop, PidParameters, StepResponseMetrics } from '@fluxlab/protocols';

type TuneState = 'idle' | 'running' | 'completed' | 'error';

interface AutoTuneStore {
  state: TuneState;
  loop: PidLoop | null;
  method: string | null;
  currentStep: number;
  totalSteps: number;
  stepMessage: string;
  resultPid: PidParameters | null;
  resultMetrics: StepResponseMetrics | null;
  errorMessage: string | null;

  setRunning: (loop: PidLoop, method: string) => void;
  setProgress: (step: number, total: number, message: string) => void;
  setResult: (pid: PidParameters, metrics: StepResponseMetrics) => void;
  setError: (message: string) => void;
  setIdle: () => void;
}

/** 自动整定状态 Store（Zustand）：管理整定进度、结果与历史记录 */
export const useAutoTuneStore = create<AutoTuneStore>((set) => ({
  state: 'idle',
  loop: null,
  method: null,
  currentStep: 0,
  totalSteps: 0,
  stepMessage: '',
  resultPid: null,
  resultMetrics: null,
  errorMessage: null,

  setRunning: (loop, method) =>
    set({
      state: 'running',
      loop,
      method,
      currentStep: 0,
      totalSteps: 0,
      stepMessage: '',
      resultPid: null,
      resultMetrics: null,
      errorMessage: null,
    }),

  setProgress: (step, total, message) =>
    set({ currentStep: step, totalSteps: total, stepMessage: message }),

  setResult: (pid, metrics) =>
    set({ state: 'completed', resultPid: pid, resultMetrics: metrics }),

  setError: (message) =>
    set({ state: 'error', errorMessage: message }),

  setIdle: () =>
    set({
      state: 'idle',
      loop: null,
      method: null,
      currentStep: 0,
      totalSteps: 0,
      stepMessage: '',
      resultPid: null,
      resultMetrics: null,
      errorMessage: null,
    }),
}));
